import MainLogo from "assets/Logos/sr-pago-main-logo.svg";

import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  image: {
    display: "block",
  },
}));

const SrMainLogo = () => {
  const classes = useStyles();

  return (
    <img src={MainLogo} alt="Sr.Pago" width="120" className={classes.image} />
  );
};

export default SrMainLogo;
